import React from "react"
import { FormattedMessage } from "react-intl"
import { BackIcon, Box, Button, DialogContentText, DialogTitle, Link } from "@carrotfertility/carotene-core"
import { DialogActionsBar, DialogTitleImage } from "@carrotfertility/carotene-core-x"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { useReimbursementContext } from "#/components/context/reimbursement/GetReimbursedContext"
import { ReimbursementDialogFraming } from "../shared/layouts"
import { TtcPaths } from "#/utils/Paths"

export const ServiceNotScheduled = (): JSX.Element => {
  const { back } = useStateMachine()
  const { onExit } = useReimbursementContext()

  return (
    <>
      <ReimbursementDialogFraming>
        <DialogTitle>
          <FormattedMessage defaultMessage="Your service hasn't been scheduled yet." />
        </DialogTitle>
        {/* Not DialogTitleWithImage: that puts the image above the title. */}
        {/* Block-level, or it won't center inside the framing. */}
        <DialogTitleImage src="/images/round-error-sign.png" alt="" sx={{ display: "block" }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: (theme) => theme.spacing(theme.tokens.spacing.md) }}>
          <DialogContentText>
            <FormattedMessage defaultMessage="We'll email you when your provider schedules the service, and then you can submit related expenses." />
          </DialogContentText>
          <DialogContentText>
            <FormattedMessage
              defaultMessage="If you have questions, <link>contact us</link>."
              values={{
                link: (linkContent) => (
                  <Link href={TtcPaths.TTC_CARE_NAV} target="_blank" color="inherit">
                    {linkContent}
                  </Link>
                )
              }}
            />
          </DialogContentText>
        </Box>
      </ReimbursementDialogFraming>
      <DialogActionsBar
        primaryAction={
          <Button color="primary" onClick={onExit}>
            <FormattedMessage defaultMessage="Close" />
          </Button>
        }
        tertiaryAction={
          <Button variant="text" color="secondary" startIcon={<BackIcon />} onClick={back}>
            <FormattedMessage defaultMessage="Back" />
          </Button>
        }
      />
    </>
  )
}
